<template>
    <SimpleTable
        :flat="true"
        title="Transacciones"
        subtitle="Historial completo de movimientos"
        :columns="columns"
        :data="transacciones"
        empty-text="No hay transacciones"
        :default-col-width="defaultColWidth"
    >
        <template #header-action>
            <span class="tw:font-bold">Balance: {{ total | formatear_precio }}</span>
        </template>
        <template #cell-importe="{ value }">
            {{ value | formatear_precio }}
        </template>
        <template #cell-descuento_aplicado="{ row }">
            <template v-if="row.descuento_aplicado > 0">
                {{ row.descuento_aplicado }} %
            </template>
            <template v-else-if="row.descuento_integro > 0">
                {{ row.descuento_integro | formatear_precio }}
            </template>
            <template v-else>
                0 %
            </template>
        </template>
        <template #cell-descuento_monedero="{ value }">
            {{ value | formatear_precio}}
        </template>
        <template #cell-importe_sin_descuento="{ value }">
            {{ value | formatear_precio}}
        </template>
        <template #cell-metodo_pago="{ value }">
            {{ formatMetodoPago(value) }}
        </template>
        <template #cell-acciones="{ row }">
            <Button
                v-if="canEditTransaction(row)"
                icon="fa fa-pen"
                @click="editarTransaccion(row)"
                size="sm"
                variant="primary"
            />
        </template>
    </SimpleTable>
</template>

<script setup>
    import { computed } from 'vue'
    import store from '@/store'
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import { canEditTransaction } from '@/composables/admin/transacciones/useEditarTransaccion'

    const props = defineProps({
        transacciones: {
            type: Array,
            default: () => []
        },
        abonado: {
            type: Object,
            required: true
        },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    })

    const emit = defineEmits(['editar-transaccion'])
    const columns = [
        { key: 'n_pedido', label: 'Nº de pedido' },
        { key: 'importe', label: 'Importe' },
        { key: 'descuento_aplicado', label: 'Descuento aplicado' },
        { key: 'descuento_monedero', label: 'Descuento monedero' },
        { key: 'importe_sin_descuento', label: 'Importe sin descuento' },
        { key: 'metodo_pago', label: 'Método de pago' },
        { key: 'fecha', label: 'Fecha' },
        { key: 'acciones', label: '', class: 'tw:w-24' }
    ]
    const total = computed(() => {
        return props.transacciones.reduce((sum, t) => sum + (t.importe || 0), 0)
    })

    const formatMetodoPago = value => {
        if (!value) return '-'
        const metodos_pago = store.getters.getTeatro?.metodos_pago_abonos_bases_ventas || []
        
        if (metodos_pago && metodos_pago.length > 0) {
            const method = metodos_pago.find(m => m.id === value)
            return method ? method.nombre : 'Método de pago no encontrado'
        }
        return '-'
    }

    function editarTransaccion(transaccion) {
        emit('editar-transaccion', transaccion)
    }
</script>
